var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 12,
    fill: "#2496ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 58,
    width: 16,
    height: 16,
    fill: "#ffffff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 58,
    width: 16,
    height: 16,
    fill: "#ffffff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 58,
    width: 16,
    height: 16,
    fill: "#ffffff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 38,
    width: 16,
    height: 16,
    fill: "#ffffff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 38,
    width: 16,
    height: 16,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 80h80c4 10 2 20-10 26-10 5-32 6-46 0-14-6-20-16-24-26z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.8067253ffba79ac9b7cbff33651b038b.svg";
export { ForwardRef as ReactComponent };